import exLanguage from '../../language';
import * as exFormat from '../format';

// ----------------------------------------------------------------------------

function create(config: Record<string, any> = {}): any {
    // Create element (datatable)
    const datatable = (window as any).jsdatatable.create({
        merge: config,
        attr: {
            id: 'listing-import',
        },
        datatable: {
            layout: {
                topStart: {
                    buttons: ['pageLength', 'delete', 'clear'],
                },
                topEnd: ['customSearch'],
            },
            columns: [
                {
                    title: '',
                    data: 'name',
                },
                {
                    title: exLanguage.line('general.filename'),
                    data: 'name',
                },
                {
                    title: exLanguage.line('general.extension'),
                    data: 'extension',
                    width: '17%',
                },
                {
                    title: exLanguage.line('general.size'),
                    data: function (row): any {
                        return exFormat.bytes(row.size, 0);
                    },
                    width: '17%',
                },
            ],
            select: {
                checkbox: true,
            },
        },
    });

    //
    return datatable;
}

// ------------------------------------------------------------------------

export { create };
